import PropTypes from "prop-types";

export default PropTypes.shape({
  applications: PropTypes.shape({
    submittedCvs: PropTypes.number.isRequired,
    cvsRead: PropTypes.number.isRequired,
    rejectedCandidates: PropTypes.number.isRequired,
    offersMade: PropTypes.bool.isRequired,
  }),
  interviews: PropTypes.shape({
    phoneInterviews: PropTypes.number.isRequired,
    competencies: PropTypes.number.isRequired,
    firstStageInterview: PropTypes.number.isRequired,
    secondStageInterview: PropTypes.number.isRequired,
  }),
  avgResponse: PropTypes.string,
});
